import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { NewsUpdateService } from '../news-update.service';

@Component({
  selector: 'app-modal-preview',
  templateUrl: './modal-preview.component.html',
  styleUrls: ['./modal-preview.component.scss']
})
export class ModalPreviewComponent implements OnInit {
  modalData;
  modalDataDetails;
  isLoading: boolean = false;
  dateAlwaysOpen: Date;
  profile;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPreviewComponent>,
    public matDialog: MatDialog,
    private newsUpdateService: NewsUpdateService,
    private sanitizer: DomSanitizer
  ) {
    this.modalData = data;
    this.modalDataDetails = this.sanitizer.bypassSecurityTrustHtml(data.newsForm.newsContent);
    this.dateAlwaysOpen = new Date;
  }

  ngOnInit() {
  }

  createNews() {
    this.isLoading = true;
    
    this.newsUpdateService.createNews(this.modalData).subscribe((res) => {
      if (res.success) {
        this.isLoading = false;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">สร้างข่าวสำเร็จแล้ว',
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
          if (!res) {
            window.opener.location.reload();
            setTimeout(() => {
              window.close()
            }, 100);
          }
        })
      }
    });
  }

  editNews() {
    // // console.log(this.modalData);
    this.isLoading = true;
    this.newsUpdateService.updateNewsById(this.modalData).subscribe((res) => {
      if (res.success) {
        this.isLoading = false;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">แก้ไขข่าวสำเร็จแล้ว',
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
          if (!res) {
            window.opener.location.reload();
            setTimeout(() => {
              window.close()
            }, 100);
          }
        })
      }
    });
  }

  dulplicateNews() {
    // // console.log(this.modalData);
    this.isLoading = true;
    this.newsUpdateService.dulplicateNews(this.modalData).subscribe((res) => {
      if (res.success) {
        this.isLoading = false;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">สร้างข่าวสำเร็จแล้ว',
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
          if (!res) {
            window.opener.location.reload();
            setTimeout(() => {
              window.close()
            }, 100);
          }
        })
      }
    });
  }
}
